<template>
    <b-autocomplete v-bind="$props"
                    v-model="lazyValue"
                    :clearable="clearable"
                    autocomplete="off"
                    v-on="$listeners"
                    data-lpignore="true"
                    :loading="loading"
                    :disabled="loading || disabled"
                    :items="items">
    </b-autocomplete>
</template>

<script>
import BAutocomplete from "@/components/General/Form/BAutocomplete";
import PropsMixin from "@/components/General/Form/Mixin/PropsMixin";

export default {
    mixins: [PropsMixin],
    components: {
        BAutocomplete
    },
    props: {
        clearable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            entries: [],
            withs: [],
            loading: true,
        }
    },
    computed: {
        lazyValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        items() {
            return this.entries.map(entry => {
                return {
                    value: entry.id,
                    text: entry.name,
                }
            })
        },
    },
    methods: {
        getAllEntries() {
            throw new Error('Create the getAllEntries method');
        },
    },
    created() {
        return this.getAllEntries().finally(() => {
            this.loading = false;
        });
    }
}
</script>
